import { render, staticRenderFns } from "./updateRole.vue?vue&type=template&id=2379f06e&scoped=true&"
import script from "./updateRole.vue?vue&type=script&lang=js&"
export * from "./updateRole.vue?vue&type=script&lang=js&"
import style0 from "./updateRole.vue?vue&type=style&index=0&id=2379f06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379f06e",
  null
  
)

export default component.exports